export const APP_CODE = 19;
export const APP_REFRESH_TOKEN_TIME = 300000;
export const TABLE = {
    ROWS: 10,
    SIZE_PER_PAGE: [5, 10, 20, 50, 100]
};
export const ACTION = {
    INSERT: "INSERT",
    UPDATE: "UPDATE",
    VIEW: "VIEW"
};
export const STATUS = {
    ACTIVE: 1,
    INACTIVE: 0
};
export const SERVICE_CODE = {
    SUCC_CODE: "API000",
    SYSTEM_ERROR: "APP001",
    NOT_FOUND: "APP002",
    DUPLICATE: "AP003",
    LOGIC_ERROR: "AP004",
    NULL_OBJ: "APP100",
};
export const DATE_FORMAT = {
    DATE_FORMAT: "DD/MM/YYYY",
    DATE_TIME_FORMAT: "DD/MM/YYYY HH:mm:ss",
    DATE_FORMAT_REV: "YYYY-MM-DD",
    DATE_TIME_FORMAT_REV: "YYYY-MM-DD HH:mm:ss",
}
export const SEPARATOR = {
    DECIMAL_SEPARATOR: ".",
    THOUSAND_SEPARATOR: ",",
}
export const FORMAT_DATE_PICKER = ["DD/MM/YYYY", "DDMMYYYY", "D/MM/YYYY", "D/M/YYYY", "D/M/YY", "D/MM/YY", "DD/M/YYYY", "DD/M/YY", "DD/MM/YY"]

export const RESPONSE_STATUS = {
    SUCCESS: "SUCCESS"
}